<template>
  <info-row
    :popup="showPopup"
    :light-title="true"
    :background-color="active ? 'yellow' : ''"
    @click="openFile(patientUpload.Data)"
  >
    <template v-slot:image>
      <i class="mdi mdi-attachment"></i>
    </template>
    <template v-slot:title>
      <span data-cy="patientuploads-patientupload-title">{{
        patientUpload.FileName
      }}</span>
    </template>
    <br />

    <template v-slot:meta>
      <div>
        {{ $filters.DateTimeFormat(patientUpload.CreatedDate) }}
        &nbsp;&bull;&nbsp;
        {{ patientUpload.MimeType }}
      </div>
    </template>

    <template v-slot:buttons>
      <i
        data-cy="patientfileuploads-patientfileupload-deletebutton"
        class="mdi mdi-trash-can-outline"
        @click.stop="confirmRemove = true"
      ></i>

      <modal-confirm
        :show="confirmRemove"
        :accept-callback="() => remove()"
        :accept-text="$t('generic.deleteShort')"
        :show-extras="false"
        :decline-text="$t('generic.cancel')"
        @close="confirmRemove = false"
        >{{ $t('modals.areYouSure') }}</modal-confirm
      >
    </template>
  </info-row>
</template>

<script>
import InfoRow from '@views/components/InfoRow/InfoRow.vue';
import PatientFileUploadModel from '@/Models/PatientFileUploadModel';

export default {
  components: { InfoRow },
  emits: ['delete'],
  props: {
    patientUpload: {
      type: PatientFileUploadModel,
      required: true
    },
    active: {
      type: Boolean
    },
    removeFunction: {
      type: Function
    }
  },
  data() {
    return {
      showDeletePopup: false,
      showEditPopup: false,
      confirmRemove: false,
      removeLoading: false
    };
  },
  mounted() {},
  methods: {
    openFile(data) {
      // Extract MIME type and raw base64
      const [header, base64] = data.split(",");
      const mimeType = header.match(/data:(.*);base64/)[1];

      // Decode base64 to byte array
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      // Create Blob and blob URL
      const blob = new Blob([byteArray], { type: mimeType });
      const blobUrl = URL.createObjectURL(blob);

      // Open blob in new tab
      window.open(blobUrl, "_blank");
    },
    remove() {
      if (!this.removeFunction) {
        return;
      }
      this.removeLoading = true;
      this.removeFunction()
        .then(() => {
          this.$emit('delete');
        })
        .finally(() => {
          this.removeLoading = false;
        });
    }
  },
  computed: {
    showPopup() {
      return this.showDeletePopup || this.showEditPopup;
    }
  }
};
</script>

<style></style>
